import { atom } from 'jotai';

export const hasMountedAtom = atom(false);
hasMountedAtom.onMount = set => set(true);
